import { QueryBarGroupItem } from "@similarweb/ui-components";

import type { ICategory, ICustomCategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";

import type { ICategoryComparison } from "../../categories-context";
import { CategoryItemWrapper, ItemContainer } from "../styles";

function isRawCategory(
    category: ICategory | ICustomCategory | ICategoryComparison,
): category is ICategory | ICustomCategory {
    return !("category" in category);
}

function resolveCategoryDisplay(category: ICategory | ICustomCategory | ICategoryComparison) {
    if (!category) {
        return {
            text: translate("industry.research.query.bar.category.invalid"),
            icon: "no-data",
            secondaryText: translate("apps.common.na"),
            color: undefined,
        };
    }
    if ("category" in category && typeof category.category === "object") {
        // ICategoryComparison
        const inner = category.category;
        return {
            text: inner.text || inner.name,
            icon: inner.isCustomCategory ? "category" : "market",
            secondaryText: inner.isCustomCategory
                ? translate("industry.research.query.bar.market")
                : translate("industry.research.query.bar.predefined"),
            color: category.color,
        };
    } else if (isRawCategory(category)) {
        // ICategory or ICustomCategory
        return {
            text: category.text || category.name,
            icon: category.isCustomCategory ? "category" : "market",
            secondaryText: category.isCustomCategory
                ? translate("industry.research.query.bar.market")
                : translate("industry.research.query.bar.predefined"),
            color: undefined,
        };
    }
}

interface IIndustryQueryBarItemProps {
    category: ICategoryComparison | ICategory | ICustomCategory;
    onItemClick: () => void;
    onItemRemove?: () => void;
    isCompare?: boolean;
}
export const IndustryAnalysisQueryBarItem = ({
    category,
    onItemClick,
    onItemRemove,
    isCompare,
}: IIndustryQueryBarItemProps) => {
    const { text, icon, secondaryText, color } = resolveCategoryDisplay(category);

    return (
        <ItemContainer>
            <CategoryItemWrapper>
                <QueryBarGroupItem
                    text={text}
                    icon={icon}
                    secondaryText={secondaryText}
                    badgeColor={color}
                    onButtonClick={onItemRemove}
                    onItemClick={onItemClick}
                    isCompare={isCompare}
                    iconName="arrow"
                    iconSize="10px"
                />
            </CategoryItemWrapper>
        </ItemContainer>
    );
};
